module.exports = __webpack_public_path__ + "img/menuboard-designer.8f1a6971.jpg";